import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "inhdialog-header" }
const _hoisted_2 = { class: "dialog_name" }
const _hoisted_3 = { class: "dialog_content" }
const _hoisted_4 = {
  key: 0,
  class: "loading-container q-mt-sm"
}
const _hoisted_5 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_6 = {
  key: 1,
  class: "inner_container"
}
const _hoisted_7 = { class: "field-group" }
const _hoisted_8 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_9 = { class: "bold-name mr-xs" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "field-group" }
const _hoisted_12 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_13 = { class: "bold-name" }
const _hoisted_14 = { class: "field-group" }
const _hoisted_15 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_16 = { class: "bold-name" }
const _hoisted_17 = { class: "field-group" }
const _hoisted_18 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_19 = { class: "bold-name" }
const _hoisted_20 = { class: "field-group" }
const _hoisted_21 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_22 = { class: "bold-name" }
const _hoisted_23 = { class: "field-group" }
const _hoisted_24 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_25 = { class: "bold-name" }
const _hoisted_26 = { class: "field-group" }
const _hoisted_27 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_28 = { class: "bold-name" }
const _hoisted_29 = { class: "field-group" }
const _hoisted_30 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_31 = { class: "bold-name" }
const _hoisted_32 = { class: "field-group" }
const _hoisted_33 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_34 = { class: "bold-name" }
const _hoisted_35 = { class: "field-group" }
const _hoisted_36 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_37 = { class: "bold-name" }
const _hoisted_38 = { class: "field-group" }
const _hoisted_39 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_40 = { class: "bold-name" }
const _hoisted_41 = { class: "field-group" }
const _hoisted_42 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_43 = { class: "bold-name" }
const _hoisted_44 = { class: "file-list" }
const _hoisted_45 = { class: "field-group" }
const _hoisted_46 = { class: "bold-name flex items-center" }
const _hoisted_47 = { class: "file-list" }
const _hoisted_48 = { class: "field-group" }
const _hoisted_49 = { class: "bold-name flex items-center" }
const _hoisted_50 = { class: "file-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_connections_table_html = _resolveComponent("connections-table-html")!
  const _component_counterparty_change_dialog = _resolveComponent("counterparty-change-dialog")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, { class: "inhdialog-container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(`${ _ctx.$t('full_info_counterparty') } "${_ctx.infoContainer.Name || ''}"`), 1),
        _createVNode(_component_app_icon, {
          name: "close",
          width: "18px",
          color: "#979797",
          "hover-color": "#499259",
          cursor: "pointer",
          title: _ctx.$t('close_label'),
          onClick: _ctx.close
        }, null, 8, ["title", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.dataLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (n) => {
                return _createElementVNode("div", {
                  key: n,
                  class: "field-group"
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "skeleton skeleton-title" }, null, -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["skeleton skeleton-text", {
                'skeleton-text-short': n % 3 === 0,
                'skeleton-text-medium': n % 3 === 1,
              }])
                    }, null, 2)
                  ])
                ])
              }), 64))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('creation_date')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.dateFormatted(_ctx.infoContainer.Date)), 1),
                  (_ctx.infoContainer.CreatedInCrm)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, ", " + _toDisplayString(_ctx.$t('created_in_one_c')), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('inn')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.infoContainer.TaxpayerNumber), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('kpp')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.infoContainer.ReasonCode), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('personal_account2')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.infoContainer.PersonalAccount), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('bank_or_settlement_account')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.infoContainer.BankAccount), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('bank_name')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.infoContainer.BankName), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('bik')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.infoContainer.BankIdCode), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('bank_correspondent_account')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.infoContainer.CorrespondentBankAccount), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('legal_address')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.infoContainer.LegalAddress), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('legal_form')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.infoContainer.LegalForm), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('comment')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.infoContainer.Note), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('linked_to_client')) + ":", 1),
                  (!_ctx.readOnly)
                    ? (_openBlock(), _createBlock(_component_app_icon, {
                        key: 0,
                        name: "edit-pencil",
                        width: "18px",
                        color: "#979797",
                        "hover-color": "#499259",
                        cursor: "pointer",
                        class: "q-ml-xs",
                        title: _ctx.$t('edit'),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCounterpartyChangeDialog = true))
                      }, null, 8, ["title"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.infoContainer.Client?.Name), 1)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.$t('incoming_invoices')), 1),
                _createElementVNode("div", _hoisted_47, [
                  (_ctx.tmp_connections_inc.length)
                    ? (_openBlock(), _createBlock(_component_connections_table_html, {
                        key: 0,
                        "model-value": _ctx.tmp_connections_inc,
                        "check-sums": false,
                        "show-sums": false,
                        "hide-remove-btn": true,
                        "read-only": _ctx.readOnly
                      }, null, 8, ["model-value", "read-only"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('outgoing_invoices')), 1),
                _createElementVNode("div", _hoisted_50, [
                  (_ctx.tmp_connections_out.length)
                    ? (_openBlock(), _createBlock(_component_connections_table_html, {
                        key: 0,
                        "model-value": _ctx.tmp_connections_out,
                        "check-sums": false,
                        "show-sums": false,
                        "hide-remove-btn": true,
                        "read-only": _ctx.readOnly
                      }, null, 8, ["model-value", "read-only"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
      ]),
      _createVNode(_component_q_dialog, {
        modelValue: _ctx.showCounterpartyChangeDialog,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showCounterpartyChangeDialog) = $event)),
        "no-shake": "",
        "full-width": !_ctx.isMobile,
        maximized: _ctx.isMobile
      }, {
        default: _withCtx(() => [
          _createVNode(_component_counterparty_change_dialog, {
            "counterparty-id": _ctx.counterpartyId,
            "current-client-id": _ctx.infoContainer.Client?.Id ?? 0,
            "current-client-name": _ctx.infoContainer.Client?.Name || '',
            onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCounterpartyChangeDialog = false)),
            onDone: _ctx.handleCounterpartyChangeDone
          }, null, 8, ["counterparty-id", "current-client-id", "current-client-name", "onDone"])
        ]),
        _: 1
      }, 8, ["modelValue", "full-width", "maximized"])
    ]),
    _: 1
  }))
}